import { DateTime } from 'luxon';
import { getTimezone } from '@/modules/people/facades/employee-workplace';

/**
 * Today as y-m-d on the location's clock, the date svc-hr gives a new job
 * assignment. Matches how the pay calendar sync dates each team member.
 */
export default function locationToday(locationId: number | string): string {
  return DateTime.local()
    .setZone(getTimezone(Number(locationId)))
    .toFormat('yyyy-MM-dd');
}
